import "./styles.scss";

const ModalWindow = ({ title, visible, loadText }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <p style={{ fontWeight: "600", color: "#25282A", fontSize: "18px" }}>
        {title}
      </p>
      <p style={{ color: "#25282A", fontSize: "14px" }}>{loadText}</p>
      <svg className="spinner" viewBox="0 0 50 50">
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="2"
        ></circle>
      </svg>
    </div>
  );
};
export default ModalWindow;
